import React, { useMemo } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/servicesTableCellsStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { Caption, HeadingSBold } from 'components/Typography/Typography';
import CustomLinearProgress from 'components/CustomLinearProgress/CustomLinearProgress';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IProgressBarCellProps {
	value: number;
	maxValue: number;
	subtitle?: string;
	title?: string;
	currency: string;
	backgroundColor?: types.newServices.backgroundColor;
}

const ProgressBarCell = ({
	value,
	maxValue,
	title,
	subtitle,
	backgroundColor = 'white',
	currency,
}: IProgressBarCellProps) => {
	const classes = useStyles();

	const progress = useMemo(() => {
		if (maxValue === 0) {
			return 0;
		}
		return (value / maxValue) * 100;
	}, [value, maxValue]);

	const valueWithUnit = useMemo(() => {
		return `${value} ${currency}`;
	}, [value, currency]);

	return (
		<div
			className={classNames(classes.cell, {
				[classes[`${backgroundColor}Color`]]: true,
			})}
		>
			<HeadingSBold disableMargin>{valueWithUnit}</HeadingSBold>
			<CustomLinearProgress
				variant="determinate"
				color={'warning'}
				value={progress}
				className={classes.linearProgress}
			/>
			<ConditionalRender
				show={!!title}
				onTrue={() => (
					<Caption color="disabled-light" disableMargin>
						{title}
					</Caption>
				)}
			/>
			<ConditionalRender
				show={!!subtitle}
				onTrue={() => (
					<Caption color="disabled-light" disableMargin>
						{subtitle}
					</Caption>
				)}
			/>
		</div>
	);
};

export default ProgressBarCell;
